import BaseService from '../services/baseService';
import ToastrService from '../services/toastrService';
import * as types from '../actions/actionTypes';
import { push } from 'react-router-redux';
import * as accountActions from '../actions/accountActions';

export default function checkAuthMiddleware() {
    return ({ dispatch, getState }) => next => action => {
        if (typeof action === 'function') {
            //we're making an async call, check if we still have a valid token
            let state = getState();
            if(state) {
                //0.08 gives us around 5 secs to expiry - 0.08 * 60
                if(state.account.token && getTokenExpiryMins(state.account.tokenExpiry) < 0.08) {
                    debugger;
                    //clear the token as it's expired and dispatch a logout event
                    if(window.location.pathname !== '/Account/Login' && window.location.pathname !== '/Account/Signup') {
                        const location = window.location.pathname;
                        dispatch(accountActions.logout(`/Account/Login?returnUrl=${location}`, false));
                        const toastrService = new ToastrService();
                        toastrService.showSuccess('', 'Your session has expired, please log in to continue');
                        return Promise.reject({message: 'Session has expired'});
                    }
                    else {
                        //we're on the login or signup page, allow the request, but clear the old token by logging out, keeping the page the same
                        dispatch(accountActions.logout(`/Account/Login?returnUrl=${window.location.pathname}`, false));
                    }
                }
            }
        }   
        return next(action);
    };
  }

  function getTokenExpiryMins(tokenExpiry) {
    const diffMs = new Date(tokenExpiry) - new Date();
    const minsToExpiry = diffMs / 1000 / 60;
    return minsToExpiry;
  }